<template>
  <div v-if="menu.Categories" class="row">
    <div ref="scrollview" class="col-sm-12 pr-spc section-search-cls scrollview" v-if="menu.Categories.length > 0" :style="modalOpen ? 'height : 100%' : 'height:'+getscrollheight+'px;position: fixed;'">
      <!-- combos category -->
      <shop-populars @show-popular="setVisibility" :isSushi="isSushi"></shop-populars>
      <section
          v-for="category in menu.Categories"
          :key="category.ID"
          :id="'section-' + category.ID"
      >
        <div class="row" v-if="porductToShow(category).length > 0">
          <div id="combos" class="category-title" :style="getStyle()"  >

            <p   :class="{'montserrat-700 mt-3' : isSushi}">    {{ getCategoryName(category) | camelCase }}</p>

            <div  :class="{'montserrat-500' : isSushi}" v-if="category.Description" v-html="getCategoryDescription(category)"></div>
          </div>
        </div>
        <div v-for="product in porductToShow(category)" :key="product.ID" class="row">
          <Product
            :product="menu.Products[product.ProductID]"
            :modifiers="menu.ModifierGroups"
            :category="product"
            :parent-category="category"
            :key="product.ID"
            :isSushi="isSushi"
            :status="getStatus(product)"
          />
        </div>



      </section>

      <div  @click="toggleModal" v-if="isSushi"  >
        <terms-and-condition   />
      </div>
      <div class="notmatchsearch" v-if="getcountproduct == 0">{{ $t('message.Nomatchingproducts') }}</div>




    </div>
    <div v-else>
      <message />
    </div>


  </div>
</template>

<script>
import Product from "./ProductMobile";
import shared from "../../../sharedscripts/shop/products/ProductList";
import { mapGetters } from "vuex";
import Message from "../../shared/Message";
import ShopPopulars from "../partials/ShopPopulars";
import { getProductStatus } from '../../../api/services/storeService.js';

import TermsAndCondition from "@/components/sushiHub/termsAndCondition";

export default {
  data() {
    return {
      popularStatus: true,
      populars: [],
      scrollheight:document.documentElement.clientHeight,
      showTerm: false,
      statuses: []
    };
  },
  name: "ProductList",
  components: { Product, Message, ShopPopulars,
    TermsAndCondition, },
  props: {
    menu: {
      type: Object,
      default: () => {}
    },
    showSearchBox: {
      type: Boolean,
      default: false
    },
    filterText: {
      type: String
    },
    ShowPopular: {
      type: Boolean,
      default: false
    },
    ShowReorder: {
      type: Boolean,
      default: false
    },
    isSushi : {
      type : Boolean
    },
    modalOpen: {
      type: Boolean,
      default: false
    },
    storeId : {
      type: String,
      required: false
    }
  },
  created() {
    this.$root.$refs.Productlist = this;
    let that = this;
    getProductStatus(this.storeId).onSnapshot(
      function(snapshot) {
        that.statuses.splice(0, that.statuses.length)
        if (!snapshot.empty) {
          snapshot.docs.forEach(doc => {
            that.statuses.push(doc);
          })
        }
      }
    )
  },
  computed: {
    ...mapGetters(["mobileStyles", "getDietarySelection"]),
    getscrollheight: function () {
      return this.scrollheight - 159
    },
    getcountproduct(){
      var count = 0;
      if(this.menu.Categories && this.menu.Categories.length > 0)
      {
        this.menu.Categories.forEach(element => {
          if(element && element.SubMenuItems)
          {
            var items = this.porductToShow(element);
            count += items.length;
          }
        });

      }
      return count;
    },
  },
  methods: {
    ...shared.methods,
    setVisibility(isVisible) {
      this.$emit('show-popular', isVisible);
    },
    toggleModal() {
      this.showTerm = !this.showTerm;

      //toggle z-index of add to cart button based on modal state
      this.$emit('toggleIndex');
    },
    getStyle() {
      var style = [];
      if(this.isSushi){
        return style;
      }
      style.push(this.mobileStyles.menu);
      style.push(this.mobileStyles.primaryColourImportant);
      return style;
    },
    porductToShow(category) {
      var items = category.SubMenuItems.filter(
          p =>
              !this.filterText ||
              p.Name.toUpperCase().indexOf(this.filterText.toUpperCase()) > -1
      );
      if (this.getDietarySelection.Allergy.length > 0) {
        items = items.filter(
            p =>
                this.getDietarySelection.Allergy.filter(a1 =>
                    p.ProductAllergy.some(a2 => a2 == a1.Id)
                ).length == this.getDietarySelection.Allergy.length
        );
      }
      if (this.getDietarySelection.Intolerance.length > 0) {
        items = items.filter(
            p =>
                this.getDietarySelection.Intolerance.filter(a1 =>
                    p.ProductIntolerance.some(a2 => a2 == a1.Id)
                ).length == this.getDietarySelection.Intolerance.length
        );
      }
      if (this.getDietarySelection.Preference.length > 0) {
        items = items.filter(
            p =>
                this.getDietarySelection.Preference.filter(a1 =>
                    p.ProductPreference.some(a2 => a2 == a1.Id)
                ).length == this.getDietarySelection.Preference.length
        );
      }
      return items;
    },
    getStatus(product) {
      const newStatus = this.statuses.filter(status => {
        if (status.id === product.ProductID.toString()) {
          return status;
        }
      })

      return newStatus.length === 0 ? product.Status : newStatus[0].data().Status;
    }
  }
};
</script>
<style scoped>
.popular::-webkit-scrollbar {
  display: none;
}
.category-title a {
  float: right;
}

.scrollview{
  overflow-y: scroll;
  overflow-x: hidden;
}
.notmatchsearch{
  text-align: center;
  margin-top: 20px;
}
</style>
